import React from 'react';

import GallerySimple from './GallerySimple';

export default React.memo(GallerySimple);
